module.exports = __webpack_public_path__ + "img/card_ip_stipulation40.14a67290.svg";